export default {
    /**
     * 登录
     */
    login: '/uc/userInfo/loginByAccount',

    // 退出
    loginOut: "/uc/userInfo/loginOut",

    /**
     * 获取用户令牌信息
     */
    findUserToken: '/uc/userInfo/findUserToken',
}